module.exports = __webpack_public_path__ + "img/img_manual3_3.1c12fb59.jpg";